@use '../../assets/styles/variables' as vars;
@use '../../assets/styles/medias.scss' as medias;

.app-shell {
  margin: 0;
  padding: 0;
}

.app-shell__header {
  padding: 1rem 1.5rem;
  align-items: center;
  background-color: vars.$darkblue;
  display: grid;
  justify-items: center;
  grid-template-areas:
    'hamburger title'
    'social social';
  gap: 16px;

  @include medias.desktop() {
    grid-template-areas: 'title navigation social';
  }
}

.app-shell__header--sticky {
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0px -5px 10px 8px vars.$faintYellow;
}

.app-shell__hamburger {
  grid-area: hamburger;

  @include medias.desktop() {
    display: none;
  }
}

.app-shell__logo {
  grid-area: title;
  text-align: center;
  display: flex;
  gap: 16px;
  align-items: center;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  text-decoration: none;
}

.app-shell__icon {
  display: none;

  @include medias.tablet() {
    display: block;
    width: 30px;
    height: 30px;
  }
}

.app-shell__title {
  margin: 0;
}

.app-shell__navigation {
  grid-area: navigation;
  display: none;

  @include medias.desktop() {
    display: block;
  }
}

.app-shell__sidemenu {
  display: block;

  @include medias.desktop() {
    display: none;
  }
}

.app-shell__social {
  grid-area: social;
}
